export default __webpack_public_path__ + "static/media/pipe-ring.95f66e4f.webp";